import React from 'react';
import MyComponent from './MyComponent';

const Wallet = () => {
    return (
        <section className="wallet-connect-area">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-7">
                        {/* Intro */}
                        <div className="intro text-center">
                            <span>Wallet-Connect</span>
                            <h3 className="mt-3 mb-0">Connect Your Wallet</h3>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum at id explicabo sit sint culpa, dolor quasi quaerat.</p>
                        </div>
                    </div>

                    
                </div>

                <div className='mt-3 d-flex justify-content-center'>
                        <MyComponent/>
                    </div>
               
            </div>
        </section>
    );
};

export default Wallet;